"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _reactResponsive = _interopRequireDefault(require("react-responsive")),
    _Files = _interopRequireDefault(require("../../Files")),
    _LinkSocialButton = _interopRequireDefault(require("./LinkSocialButton"));

require("../styles/_social-profiles-content.scss");

var SMALL_BREAKPOINT = 565;

function SocialProfilesContent(_ref) {
  var socialProfiles = _ref.socialProfiles,
      onSave = _ref.onSave,
      allowedSocialTypes = _ref.allowedSocialTypes,
      modalTitle = _ref.modalTitle,
      modalDescription = _ref.modalDescription,
      buttonTitle = _ref.buttonTitle,
      onSelectImage = _ref.onSelectImage,
      disabled = _ref.disabled;
  return [_react["default"].createElement("div", {
    className: "social-profiles-content",
    key: "image-upload"
  }, disabled ? null : _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("p", null, "EDIT AVATAR"), _react["default"].createElement(_Files["default"], {
    onFilesChange: onSelectImage,
    allowedTypes: ["image"],
    minFileSize: 0,
    clickable: !0
  }, _react["default"].createElement(_uiKit.Button, {
    type: "INVERTED",
    small: !0
  }, "BROWSE FILE"))), _react["default"].createElement(_reactResponsive["default"], {
    maxWidth: SMALL_BREAKPOINT
  }, _react["default"].createElement(_LinkSocialButton["default"], {
    socialProfiles: socialProfiles,
    allowedSocialTypes: allowedSocialTypes,
    onSave: onSave,
    hideLabel: !0,
    disabled: disabled
  }))), _react["default"].createElement(_reactResponsive["default"], {
    minWidth: SMALL_BREAKPOINT + 1,
    key: "link-social-btn"
  }, _react["default"].createElement(_LinkSocialButton["default"], {
    socialProfiles: socialProfiles,
    onSave: onSave,
    modalTitle: modalTitle,
    modalDescription: modalDescription,
    buttonTitle: buttonTitle,
    allowedSocialTypes: allowedSocialTypes,
    disabled: disabled
  }))];
}

var _default = (0, _react.memo)(SocialProfilesContent);

exports["default"] = _default;